import { ProgramsSideBarDatamodel } from '../side-bar/programs-side-bar-datamodel';
import appApi from '../../../api/app-api';
import { toast } from 'react-toastify';
import { ReportProgramResponseType } from '../../../api/types/reports/education/programms/report-program-response.type';
import { displayErrorText } from '../../../api/errors/api-error-codes';

export const getProgramsOperations = async (
  filters: ProgramsSideBarDatamodel,
  offset: number,
  limit: number,
  setLoading: (loading: boolean) => any,
  setData: (data: ReportProgramResponseType[]) => any,
  setTotal: (total: number) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getProgramsReport({
      ...filters,
      offset,
      limit,
    });
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }

    const paginationResponse = res.data.body;

    // Ensure we have valid pagination response
    if (!paginationResponse) {
      setData([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    if (!Array.isArray(paginationResponse.data)) {
      console.error('Invalid data in pagination response:', paginationResponse);
      setData([]);
      setTotal(0);
      setLoading(false);
      return;
    }

    setData(paginationResponse.data);
    const totalCount = paginationResponse.total ?? 0;
    setTotal(totalCount);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
